    @if (input_readonly$$()) {
        <app-input-control
            [appearance]="input_appearance$$()"
            [color]="input_color$$()"
            [classHeight]="input_classHeight$$()"
            [value]="value"
            [floatLabel]="input_floatLabel$$()"
            [hideRequiredMarker]="hideRequiredMarker$$()"
            [hintAlign]="input_hintAlign$$()"
            [hintLabel]="input_hintLabel$$()"
            [hint]="input_hint$$()"
            [label]="input_label$$()"
            [readonly]="true"
            [subscriptSizing]="input_subscriptSizing$$()"
        />
    } @else {
        <app-select-control
            (openedChange)="emit_openedChange($event)"
            (selectionChange)="emit_selectionChange($event)"
            (valueChange)="emit_valueChange($event)"
            [appearance]="input_appearance$$()"
            [ariaLabel]="input_ariaLabel$$()"
            [ariaLabelledBy]="input_ariaLabelledBy$$()"
            [autofocus]="input_autofocus$$()"
            [canSelectNullableOptions]="input_canSelectNullableOptions$$()"
            [classHeight]="input_classHeight$$()"
            [color]="input_color$$()"
            [compareWith]="input_compareWith$$()"
            [controlName]="input_controlName$$()"
            [control]="input_control$$()"
            [disableOptionCentering]="input_disableOptionCentering$$()"
            [disableRipple]="input_disableRipple$$()"
            [disabled]="input_disabled$$()"
            [errorStateMatcher]="input_errorStateMatcher$$()"
            [fieldName_display]="input_fieldName_display$$()"
            [fieldName_value]="input_fieldName_value$$()"
            [floatLabel]="input_floatLabel$$()"
            [hideLineRipple]="input_hideLineRipple$$()"
            [hideRequiredMarker]="hideRequiredMarker$$()"
            [hideSingleSelectionIndicator]="input_hideSingleSelectionIndicator$$()"
            [hintAlign]="input_hintAlign$$()"
            [hintLabel]="input_hintLabel$$()"
            [hint]="input_hint$$()"
            [id]="input_id$$()"
            [label]="input_label$$()"
            [list]="input_list$$()"
            [multiple]="input_multiple$$()"
            [panelClass]="input_panelClass$$()"
            [panelWidth]="input_panelWidth$$()"
            [placeholder]="input_placeholder$$()"
            [required]="input_required$$()"
            [showError]="input_showError$$()"
            [sortComparator]="input_sortComparator$$()"
            [subscriptSizing]="input_subscriptSizing$$()"
            [typeAheadDebounceInterval]="input_typeAheadDebounceInterval$$()"
        />
    }
